// src/utils/logout.js
// Common logout handler for both admin and main UIs

export function handleLogout({ setIsAuthenticated, navigate } = {}) {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("refreshToken");
  if (typeof setIsAuthenticated === "function") {
    setIsAuthenticated(false);
  }
  if (typeof navigate === "function") {
    navigate("/login");
  } else {
    window.location.href = "/login";
  }
}
